import isServer from "../../common-utils/environment/isServerSide.util.js";
const domains = {
    prod: "prod",
    acc: "acc",
    test: "test",
    opleiding: "other",
    demo: "other",
};
const domainCaptions = {
    prod: "Productie",
    acc: "Acceptatie",
    demo: "Demo",
    opleiding: "Opleiding",
    test: "Test",
};
const isValidTypeValue = (input) => input && input.trim() ? ["prod", "acc", "demo", "opleiding", "test"].includes(input) : false;
export const deploymentEnviromentUtil = () => {
    if (isServer())
        return;
    const url = window.location.hostname;
    if (!url)
        return;
    // See below for more information about regex.
    const environmentRegex = /^([^.]+)\.(?:([a-zA-Z0-9]+)-)?[^.]+\.nl$/i;
    const tenantAndEnvironment = url.match(environmentRegex);
    if (!tenantAndEnvironment)
        return;
    // If there is a match:
    // - The first caption group, being tenant, is stored as the second property of the object.
    // - The second caption group, being environment, is stored as the third property of the object.
    const environment = tenantAndEnvironment[2]?.toLowerCase() ?? "prod";
    if (isValidTypeValue(environment)) {
        return {
            tenant: tenantAndEnvironment[1]?.toLowerCase(),
            domain: domains[environment],
            isProduction: environment === "prod",
            label: domainCaptions[environment],
        };
    }
};
export default deploymentEnviromentUtil;
/**
 * Extracts the tenant and optional environment part from a URL.
 *
 * The URL follows the format:
 *   <tenant>.<environment>-<applicationname>.nl
 * Where:
 *   - <tenant> is the customer's name (no special constraints).
 *   - <environment> is an optional string (could be empty or non-empty).
 *   - <applicationname> is the application name.
 *
 * The goal of this function is to extract the tenant and environment part (if it exists) and return it.
 * It's returned as production (prod) environments if no environment part is found.
 *
 * Regex breakdown:
 *
 *   ^([^.]+)               - Captures the <tenant> at the start of the string.
 *                            This matches one or more characters that are not dots (.) up until the first dot.
 *
 *   \.                     - Matches the literal dot (.) separating <tenant> from the rest of the URL.
 *
 *   (?:([a-zA-Z0-9]+)-)?   - Lazily captures the <environment> part, if it exists.
 *                            - [a-zA-Z0-9]+  It matches alphanumeric characters for the <evironment>.
 *                            - The - ensures it only matches if there is a dash following the <environment>.
 *                            - The ? makes this group optional.
 *
 *   [^.]+                  - Matches the <applicationname> after the hyphen, which can be
 *                            any sequence of characters except a dot (.) up to the next dot.
 *
 *   \.nl$                  - Matches the ".nl" domain at the end of the string.
 *                            This ensures the URL ends with ".nl" and confirms the proper structure.
 *
 *   /i                     - Case-insensitive
 */
